import React from 'react';
import './FireEffect.scss';

type PropTypes = {
  small?: boolean;
};

export const FireEffect = ({ small }: PropTypes) => {
  return (
    <div className="fire">
      {Array.from({ length: 50 }).map((_, index) => (
        <div
          key={index}
          className={`particle ${small ? 'particle-small' : 'particle-large'}`}
        ></div>
      ))}
    </div>
  );
};
